import { Injectable, Injector } from '@angular/core';
import { ListData } from '@fi-app/components/items-list/list-data.service';
import { IGetInstanceService } from '@fi-app/utilities/fi-model/get-instance-service';
import { ChecklistService } from '@fi-app/checklist/checklist.service';
import { ObjectTypes } from '@fi-shared/types/object-type';
import {
    ItemsListElementType,
    ItemsListHeader,
    ItemsListHeaderProperties,
} from '../components/items-list/items-list-header';
import { AccessToApplicationTypeService } from '@fi-shared/fi-shared-services/access-to-application-type.service';
import { ApplicationSettingsType } from '@fi-shared/types/application-settings-type';
import { AccessRightType } from '@fi-shared/types/access-right-type';
import { ChecklistModel } from '@fi-app/checklist/checklist.model';
import { FiStateNames } from '@fi-shared/fi-state-proxy/fi-state-names';
import { truncateAtWord } from '@fi-shared/utils/truncate-at-word';

@Injectable()
export class ChecklistTemplateListDataService implements IGetInstanceService {
    constructor(
        private injector: Injector,
        private accessToApplicationTypeService: AccessToApplicationTypeService,
        private checklistService: ChecklistService,
    ) {}

    getInstance(isLocalSort?: boolean) {
        return new ChecklistTemplateListData(
            this.injector,
            this.accessToApplicationTypeService,
            this.checklistService,
            isLocalSort,
        );
    }
}

export class ChecklistTemplateListData extends ListData<ChecklistModel> {
    constructor(
        injector: Injector,
        accessToApplicationTypeService: AccessToApplicationTypeService,
        checklistService: ChecklistService,
        isLocalSort?: boolean,
    ) {
        super(injector, isLocalSort);

        this.ShowFavoriteIcon = true;

        this.ObjectType = ObjectTypes.CheckListTemplate;

        this.DeletePermanentlyTextId = 'checklist.delete_template_permanently_confirm';

        this.ShowFavoriteIcon = false;

        this.IconClass = 'fi-icon-checklist';

        this.GetItemName = (isPlural) => {
            return this.appTextService.get(!isPlural ? 'common.template' : 'templates');
        };

        this.ShowDelete = this.ShowCheckBox = accessToApplicationTypeService.HasAccessToApplicationType(
            ApplicationSettingsType.ChecklistLocal,
            AccessRightType.Admin,
        );

        this.Header.push(
            new ItemsListHeader(
                '',
                '',
                new ItemsListHeaderProperties(
                    'CcmListItem-Icon CcmListItem-NoBorder ccmListViewHiddenCell',
                    true,
                    ItemsListElementType.ImgIconA,
                    {
                        Sref: () => {
                            return FiStateNames.Checklist.Template.View;
                        },
                        SrefParams: (data) => {
                            return { Id: data.Id };
                        },
                    },
                ),
            ),
        );

        this.Header.push(
            new ItemsListHeader(
                this.appTextService.get('common.name'),
                'Name',
                new ItemsListHeaderProperties('CcmListItem-Name', true, ItemsListElementType.A, {
                    Sref: () => {
                        return FiStateNames.Checklist.Template.View;
                    },
                    SrefParams: (data) => {
                        return { Id: data.Id };
                    },
                }),
            ),
        );

        this.addSpanPlainHeader(this.appTextService.get('checklist.checkpoints'), 'CheckPointsCount');

        this.addDescriptionHeader();

        this.addChangedOnHeader();

        this.addCreatedByHeader();

        this.deleteFunc = (ids) => checklistService.DeleteCheckListTemplates(ids);

        const self = this;
        this.appendData = ((appendDataOrig) => {
            return (items) => {
                items.forEach(function (item) {
                    item.Description = truncateAtWord(item.Description, Number.MAX_SAFE_INTEGER, true);
                });
                appendDataOrig.call(self, items);
            };
        })(this.appendData);
    }
}
